import { BrandingTypeEnum } from "gql/generated.graphql";

export const getBrandingTypeOptions = (t: any, includeAll = false) => {
  const options = [
    { label: t("common:labels.unbranded"), value: BrandingTypeEnum.Unbranded },
    { label: t("common:labels.branded"), value: BrandingTypeEnum.Branded },
    { label: t("common:labels.shared"), value: BrandingTypeEnum.Shared },
  ];

  if (includeAll) {
    return [{ label: t("common:labels.all"), value: "" }, ...options];
  }

  return options;
};